export interface CasesResult<T> {
  cases: T[];
  totalCases: number;
}

export interface RegisteredCase {
  id?: string;
  createDate?: string;
  updateTime?: string;
  readTime?: string;
  salesForceId?: string;
  state?: string;
  syncError?: string;
  value: Case;
  userId?: string;
  weight?: number;
  isValid?: boolean;
  validationResultsModel?: any[];
  lastUpdate: string;
}

export interface IFilteredCase {
  id?: string;
  country: string;
  firstName: string;
  lastName: string;
  primaryPhone: any;
  accountNumber: string;
  createdDate?: string;
  priority:string;
}
export class FilteredCase implements IFilteredCase {
  constructor(
    public country: string,
    public firstName: string,
    public priority:string,
    public lastName: string,
    public primaryPhone: any,
    public accountNumber: string,
    public id?: string,
    public createDate?: string,
  ) {}
}

export interface Case {
  caseDetails: {
    countryId: string;
    businessUnit: string;
    caseCategory: string;
    caseSubCategory: string;
    receivedFrom: string;
    subject: string;
    description: string;
  };
  contactDetails: {
    contactType: string;
    firstName: string;
    lastName: string;
    accountNumber: string;
    accountName: string;
    country: string;
    street: string;
    city: string;
    stateProvince: string;
    postalCode: string;
    primaryPhone: any;
    phoneExt: string;
    mobilePhone: any;
    email: string;
    fax: string;
    language: string;
    languageCode: string;
    preferredChannel: string;
    openTime: string;
    closeTime: string;
  };
  shippingTypeIdentifiers: {
    identifier: string;
    value: string;
  }[];
  requestAssistance: {
    contactRole: string;
    priority: string;
    premierShipment: string,
    //contactRequired: string;
    contact: string;
    differentAddress: {
      firstName: string;
      lastName: string;
      country: string;
      street: string;
      city: string;
      state: string;
      postalCode: string;
      accountNumber: string;
    };
    phoneNumber: any;
    phoneExt: string;
    email: string;
    language: string;
    languageCode: string;
    preferred: string;
    assistance: string;
  };
}

export enum CasesType {
  ALLCASES = 'AllCases',
  MYCASES = 'MyCases',
}

export enum SyncStatusEnum {
  SYNC_ERROR = 'Sync_Error',
  SYNC_SUCCESS = 'Sync_Success',
  SYNC_IN_PROGRESS = 'Sync_In_Progress',
}
